const DEFAULT_CACHE_EXPIRE_TIME = 24 * 60 * 60 * 1000 // 24 giờ

const getCacheKey = ({ searchType, keyword }) => {
  return `${searchType || ''}_${String(keyword || '').trim()}`
}

const safeParseJson = (value) => {
  if (!value) return null

  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

export const getTaxLookupResponseCache = ({ storageKey, searchType, keyword }) => {
  try {
    const cachedValue = localStorage.getItem(storageKey)
    const cachedMap = safeParseJson(cachedValue) || {}
    const cacheKey = getCacheKey({ searchType, keyword })
    const cachedItem = cachedMap[cacheKey]

    if (!cachedItem) return null

    const now = Date.now()
    const createdAt = cachedItem.createdAt || 0

    if (now - createdAt > DEFAULT_CACHE_EXPIRE_TIME) {
      delete cachedMap[cacheKey]
      localStorage.setItem(storageKey, JSON.stringify(cachedMap))
      return null
    }

    return cachedItem.data || null
  } catch (error) {
    return null
  }
}

export const saveTaxLookupResponseCache = ({ storageKey, searchType, keyword, data }) => {
  try {
    const cachedValue = localStorage.getItem(storageKey)
    const cachedMap = safeParseJson(cachedValue) || {}
    const cacheKey = getCacheKey({ searchType, keyword })

    cachedMap[cacheKey] = {
      data,
      createdAt: Date.now()
    }

    localStorage.setItem(storageKey, JSON.stringify(cachedMap))
  } catch (error) {
    // ignore localStorage error
  }
}

export const clearTaxLookupResponseCache = (storageKey) => {
  try {
    localStorage.removeItem(storageKey)
  } catch (error) {
    // ignore localStorage error
  }
}